module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAu0lEQVR4AWOgD6iyhaOvv77/RwJALrIsFg0QdQfvnTz64AyETVjDxx+fAxdnZGyoI1bDlhsHdCf4O81OuPf2MWENf/7+ydrYaj4tUrTJMXlt099/fwlo+Przm//ifPVef8kWF9uZyW++viOg4fmnF+HLCqXbPTX7Aq2mRZ95comAhvYDc0SanPgaHNhqrBU73PuPzCegYemFraXb+oOXlqeta99x8/DZp5eJioftt45tu3kUM1hJj+lBCQDhWtHjpM40oQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/NF.png
// module id = 1226
// module chunks = 0